import React from 'react';
import Skeleton from 'react-loading-skeleton';
const LessonGridLoader = () => {
    const columns = [1, 2, 3, 4, 5];
    return (React.createElement("div", { style: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: '1rem',
            padding: '0 .3125rem'
        } }, columns.map((column, index) => (React.createElement("div", { key: `column-${index}`, style: {
            width: '95%',
            height: 40,
            display: 'grid',
            justifyContent: 'center',
            alignItems: 'center',
            gridTemplateColumns: '5% 65% 15% 15%',
            gap: '1rem',
            padding: '0 .3125rem',
            margin: '0 auto'
        } },
        React.createElement(Skeleton, { width: '100%', height: 40, count: 1 }),
        React.createElement(Skeleton, { width: '100%', height: 40, count: 1 }),
        React.createElement(Skeleton, { width: '100%', height: 40, count: 1 }),
        React.createElement(Skeleton, { width: '100%', height: 40, count: 1 }))))));
};
export default LessonGridLoader;
